<section *ngIf="heColaborador && dependentInclusion !== null" id="top-section">
  <div class="col-md-12 mt-5">
    <h4 class="form-section d-flex justify-content-center align-center">
      <b>DECLARAÇÃO DE SAÚDE</b>
    </h4>
    <div class="col-md-12 d-flex justify-content-center align-center mt-1" style="line-height: 1.5">
      <div class="col-md-9 col-sm-12">
        <p class="preto-geia">
          Preencha abaixo o seu formulário de declaração de saúde e de seus dependentes, clique no sim(em caso de
          reposta afirmativa, descreva a data do evento e especifique ao lado) ou não (em caso de resposta negativa).
        </p>
      </div>
    </div>
    <br />
    <div class="col-12 mb-3">
      <div class="form-actions float-left">
        <h4 class="form-section">
          <div *ngIf="heColaborador">
            <strong>Olá, Colaborador</strong>
          </div>
        </h4>
      </div>
      <div class="form-actions float-right">
        <button
          id="btnLimpar"
          (click)="abrirModal()"
          data-toggle="modal"
          data-target="#exportarTabela"
          type="button"
          class="btn cursor-pointer btn-round white btn-min-width box-shadow-4"
          style="background-color: #6c757d !important">
          <i class="fa fa-download white"></i>
          Exportar
        </button>
      </div>
    </div>
  </div>
  <!-- Abas (click)="enviarListaTitular()" -->
  <ul class="nav nav-tabs nav-justified">
    <li *ngIf="!dependentInclusion" class="nav-item cursor-pointer">
      <a
        class="nav-link"
        [ngClass]="{'active show': activeTab === 'titular'}"
        (click)="activeTab = 'titular'; enviarListaTitular(); stepper.selectedIndex = 0"
        id="activeLable-tab"
        data-toggle="tab"
        href="#activeLable"
        aria-controls="activeLable"
        aria-expanded="true">
        TITULAR
      </a>
    </li>
    <li class="nav-item cursor-pointer" *ngIf="mostrarAbaDependente">
      <a
        class="nav-link"
        [ngClass]="{'active show': activeTab === 'dependente'}"
        (click)="activeTab = 'dependente'; stepper.selectedIndex = 1; abaDependenteTocada = true"
        id="aba-depente"
        data-toggle="tab"
        href="#linkLable"
        aria-controls="linkLable"
        aria-expanded="false">
        DEPENDENTE(S)
      </a>
    </li>
  </ul>
  <!-- Conteúdo das Abas -->
  <div class="tab-content px-1 pt-1" [ngClass]="{'validation-triggered': ehValido}">
    <!-- Abas -->
    <div
      role="tabpanel"
      class="tab-pane active show"
      id="activeLable"
      aria-labelledby="activeLable-tab"
      aria-expanded="true">
      <mat-horizontal-stepper [linear]="isLinear" #stepper>
        <!-- Stepper de Titular -->
        <mat-step label="TITULAR" *ngIf="!dependentInclusion || dependentInclusion !== null">
          <app-perguntas-declaracao-saude
            [dependentInclusion]="dependentInclusion"
            [ehColaborador]="heColaborador"
            [nome]="nomeTitular"
            [aniversario]="dataDeNascimentoTitular"
            [estadoCivil]="estadoCivilTitular"
            [tipoProposta]="tipoPropostaTitular"
            (adicionarNaListaFinal)="receberRespostaColaborador($event)"></app-perguntas-declaracao-saude>
        </mat-step>
        <!-- Stepper de Dependente -->
        <mat-step label="DEPENDENTE" *ngIf="mostrarAbaDependente">
          <div class="tab-pane" id="linkLable" role="tabpanel" aria-labelledby="linkLable-tab" aria-expanded="false">
            <div class="card">
              <div class="card">
                <div class="card-body">
                  <div class="card-header card-form-header mt-1">
                    <div
                      *ngFor="let dependente of listaBeneficiariosDependentes; let i = index"
                      class="card collapse-icon accordion-icon-rotate"
                      style="margin-bottom: 1rem">
                      <div
                        id="dependentHeader{{ i }}"
                        class="card-header collapse-format border-info"
                        [class.border-info]="!ehValido || dependenteValido[dependente.id]">
                        <a
                          class="card-title lead cursor-pointer d-flex justify-content-between align-items-center"
                          (click)="toggleDependent(dependente.id)">
                          <div class="info">
                            <i
                              class="fa fa-user mr-2"
                              aria-hidden="true"
                              [class.info]="!ehValido || dependenteValido[dependente.id]"></i>
                            <span [class.info]="!ehValido || dependenteValido[dependente.id]">
                              Dependente - {{ dependente.name }}
                            </span>
                          </div>
                          <span
                            class="accordion-icon"
                            [class.plus]="!isDependentOpen(dependente.id)"
                            [class.minus]="isDependentOpen(dependente.id)"
                            [class.info]="!ehValido || dependenteValido[dependente.id]"></span>
                        </a>
                      </div>

                      <div
                        [id]="'colapseDependente' + i"
                        role="tabpanel"
                        class="card-collapse collapse"
                        [class.show]="isDependentOpen(dependente.id)">
                        <app-perguntas-declaracao-saude
                          [ehColaborador]="heColaborador"
                          [nome]="dependente?.name"
                          [aniversario]="dependente?.birthDate"
                          [estadoCivil]="dependente?.civilStatus?.name"
                          [tipoProposta]="dependente?.proposalType"
                          (adicionarNaListaFinal)="receberRespostaColaborador($event)"></app-perguntas-declaracao-saude>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
      <!-- Botão Enviar -->
      <div class="button-mobile d-flex justify-content-end w-100 mt-2">
        <button
          class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 mr-1 mb-1"
          style="box-shadow: none"
          (click)="gotoTop()">
          <i class="fa fa-arrow-up"></i>
          Voltar ao Topo
        </button>
        <ng-container *ngIf="this.stepAtual == propostaEnum.VIDEO_CONFERENCIA && podeCadastrarEditar">
          <app-declinio-proposta
            [stepAtual]="stepAtual"
            (propostaDeclinada)="receberDeclinio($event)"></app-declinio-proposta>
          <button
            class="btn cursor-pointer btn-round btn-success-geia white btn-min-width mb-1"
            style="box-shadow: none"
            (click)="colaboradorAvancar()">
            <i class="fa fa-send"></i>
            Enviar
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</section>
<!-- Modal para exportar lead -->
<app-modal
  [sizeModal]="sizeModal"
  [id]="idModal"
  [titleModal]="titleModal"
  [hideCloseButton]="hideCloseButton"
  (closeModal)="fecharModal()">
  <div id="exportarTabela">
    <p>Exportar dados via:</p>
    <form [formGroup]="formGrupRespostaQuestionario">
      <div class="col-12">
        <div class="form-group row">
          <!-- Tipo -->
          <div class="form-group col-sm-12 col-md-12 mt-1">
            <label for="typeExport">Tipo</label>
            <ng-select
              id="typeExport"
              class="round shadow"
              [multiple]="false"
              [loading]="false"
              [closeOnSelect]="true"
              [searchable]="false"
              formControlName="typeExport"
              notFoundText="Nenhum registro localizado"
              [ngClass]="{
                'campo-obrigatorio': formGrupRespostaQuestionario.controls['typeExport'].errors && isFormSubmited
              }">
              <ng-option *ngFor="let option of tipoDocExportar" [value]="option.valor">
                {{ option.descricao }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>
    </form>
    <!-- Botões -->
    <div class="form-actions mb-1 float-right" style="text-align: right; margin-top: 10px">
      <button
        data-dismiss="modal"
        (click)="fecharModal()"
        type="button"
        class="btn btn-round btn-geia-info btn-outline-info btn-min-width box-shadow-4 btn-min-width mr-1 mb-1">
        <i class="ft-x"></i>
        Cancelar
      </button>
      <button
        (click)="exportarDados()"
        type="button"
        class="btn cursor-pointer btn-round btn-success-geia white btn-min-width box-shadow-4 mr-1 mb-1">
        <i class="fa fa-download white"></i>
        Exportar
      </button>
    </div>
  </div>
</app-modal>

<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff">
  <p style="color: white">Carregando...</p>
</ngx-spinner>
